import { SUPPORT_EMAIL } from '../constants/external-links';

const getSupportContactLink = (contact?: string | null) => {
  const supportContact = contact ?? SUPPORT_EMAIL;
  const supportHref = supportContact.includes('@')
    ? `mailto:${supportContact}`
    : `tel:${supportContact.replace(/\s+/g, '')}`;

  return { supportContact, supportHref };
};

export { getSupportContactLink };
